import _classCallCheck from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\xams.UI.Web.Player\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
export var HeaderNames = function HeaderNames() {
  _classCallCheck(this, HeaderNames);
};
HeaderNames.Authorization = "Authorization";
HeaderNames.Cookie = "Cookie";